export default {
  phoneNumberMismatch: {
    id: 'myprofile_country_dial_phone_number_mismatch_error',
    defaultMessage: 'Phone number does not match with the country dial-in code',
  },
  postalCodeInvalid: {
    id: 'address_fields_postal_code_invalid',
    defaultMessage: 'ZIP code is invalid',
  },
}
